import { useEffect, useRef } from 'react';
import TextArea from 'antd/es/input/TextArea';
import ReactDataSheet from 'react-datasheet';
import DataEditor = ReactDataSheet.DataEditor;
import DataEditorProps = ReactDataSheet.DataEditorProps;
import { ColumnType, Value } from './types';

type Props = DataEditorProps<Value> & {
  type: ColumnType;
};

export const CustomDataEditor: DataEditor<Props> = (props: Props) => {
  const ref = useRef<HTMLInputElement>();

  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, []);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange(e.target.value);
  };
  const onTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    props.onChange(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' && (e.shiftKey || e.altKey) && props.type === 'textarea') {
      return;
    }
    props.onKeyDown(e);
  };


  if (props.type === 'textarea') {
    return (
        <TextArea className={'data-editor'} ref={ref} onChange={onTextAreaChange} onKeyDown={handleKeyDown} value={props.value}></TextArea>
    );
  }

  return (
      <input className={'data-editor'} ref={ref} onChange={onChange} onKeyDown={handleKeyDown} value={props.value}></input>
  );

  // <input ref={ref} onChange={onChange} className={'data-editor'} onKeyDown={props.onKeyDown} value={props.value}></input>
};
